import { Col, Offcanvas, Row } from "react-bootstrap"
import { useWarehouse } from "../context/WarehouseProvider"
import { useEffect, useState } from "react";
import * as apiWarehouse from "api/apiWarehouses";
import ESpinner from "../../others/Spinner";
import { useTranslation } from "react-i18next";
import ProductTitle from "../../Products/ProductRowItems/ProductTitle";
import OperationTable from "./OperationTable";
import Paginator from "../../others/Paginator";
import { useAuth } from "context/AuthContext";
import { getStoredListPageSize } from "utils/helpers/list/listPageSize";

const WAREHOUSE_OPERATIONS_PAGE_SIZE_KEY = 'warehouse-operations';

const OffWarehouseOperations = () => {
    const PaginatorAny = Paginator as any;

    const { t } = useTranslation(['Warehouses']);
    const { auth } = useAuth();
    const { wOperation, setWOperation} = useWarehouse();
    const [ operList, setOperList ] = useState(null);
    const [ wrongCount, setWrongCount ] = useState(false);
    const [ page, setPage ] = useState(1);
    const [ onPage, setOnPage ] = useState(() => getStoredListPageSize(auth?.user?.ID, WAREHOUSE_OPERATIONS_PAGE_SIZE_KEY));

    const fetchOperation = async ({warehouseId, productId}: any) => {
        const resOperations = await apiWarehouse.getOperations(warehouseId, productId, {page, onPage});
        setOperList(resOperations);
    }

    const handleClode = () => {
        setWOperation(null);
        setTimeout(() => {
            setOperList(null);
        }, 300);
    }
 
    useEffect(()=>{
        if (wOperation) fetchOperation(wOperation);
    }, [wOperation, page, onPage])

    useEffect(()=>{
        setWrongCount(wOperation?.stockCount !== operList?.stockCount);
    },[operList?.stockCount])

    return (
        <Offcanvas className="offcanvas-bottom"
            placement="bottom" 
            show={wOperation!==null}
            onHide={handleClode}> 

            <Offcanvas.Header closeButton className="border-bottom">
                <Offcanvas.Title>{t('titleOper')}</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                <div className="off-warehouse-operations d-flex flex-column h-100">
                    <div className="off-warehouse-operations-content px-3">
                        {operList ? (
                            <>
                                <Row className="d-flex align-items-center mx-0">
                                    <ProductTitle product={operList?.product} />

                                    {wrongCount && (
                                        <Col xs="auto">
                                            <span className="badge rounded-pill text-bg-danger">{t('wrongCount')}</span>
                                        </Col>
                                    )}
                                </Row>

                                <OperationTable operations={operList?.operations} />
                            </>
                        ) : (
                            <ESpinner />
                        )}
                    </div>

                    {operList?.paginator && (
                        <div className="p-3 offcanvas-footer off-warehouse-operations-footer">
                            <PaginatorAny
                                paginator={operList?.paginator}
                                storageKey={WAREHOUSE_OPERATIONS_PAGE_SIZE_KEY}
                                onChangePage={(nextPage) => {
                                    setPage(nextPage);
                                }}
                                onChangeOnPage={(nextOnPage) => {
                                    setOnPage(nextOnPage);
                                    setPage(1);
                                }}
                            />
                        </div>
                    )}
                </div>
            </Offcanvas.Body>
        </Offcanvas>)
}

export default OffWarehouseOperations;
